import { WORK_PERMIT_STATUS } from '../consts'
import {
  WORK_PERMIT_HISTORY_DISPLAY_LAYOUT,
  createWorkPermitHistoryDisplayDecision,
} from './contracts'
import {
  historyRowIsApprOrReject,
  historyTextMeaningful,
} from './commentContent'

/**
 * author: alvis
 * timestamp: 2026-05-07
 * description: Check whether an engineer history row should use the split internal/external layout.
 * @param {Object} params
 * @param {Object} params.item
 * @param {boolean} params.isEngineer
 * @param {string} [params.emptyValue]
 * @returns {boolean}
 */
export function historyRowShouldShowEngineerCommentSplit ({
  item,
  isEngineer,
  emptyValue = '--',
}) {
  if (!isEngineer) return false
  return historyTextMeaningful(item.externalContent, emptyValue)
}

/**
 * author: alvis
 * timestamp: 2026-05-07
 * description: Pure UI decision helper for Work Permit history rows.
 * Keeps WPCollapseContent rendering behavior stable while centralizing branch selection.
 * @param {Object} params
 * @param {Object} params.item
 * @param {boolean} params.isEngineer
 * @param {string} [params.emptyValue]
 * @returns {import('./contracts').WorkPermitHistoryDisplayDecision}
 */
export function getWorkPermitHistoryDisplayDecision ({
  item,
  isEngineer,
  emptyValue = '--',
}) {
  if (!item) {
    return createWorkPermitHistoryDisplayDecision()
  }
  if (isEngineer && item.status === WORK_PERMIT_STATUS.APPR) {
    return createWorkPermitHistoryDisplayDecision({
      layout: WORK_PERMIT_HISTORY_DISPLAY_LAYOUT.ENGINEER_APPROVER_SINGLE,
    })
  }
  if (isEngineer && !historyRowShouldShowEngineerCommentSplit({ item, isEngineer, emptyValue })) {
    return createWorkPermitHistoryDisplayDecision({
      layout: WORK_PERMIT_HISTORY_DISPLAY_LAYOUT.ENGINEER_INTERNAL_OR_EMPTY,
    })
  }
  if (historyRowShouldShowEngineerCommentSplit({ item, isEngineer, emptyValue })) {
    return createWorkPermitHistoryDisplayDecision({
      layout: WORK_PERMIT_HISTORY_DISPLAY_LAYOUT.ENGINEER_REVIEWER_SPLIT,
    })
  }
  if (item.externalContent && !isEngineer && !historyRowIsApprOrReject(item)) {
    return createWorkPermitHistoryDisplayDecision({
      layout: WORK_PERMIT_HISTORY_DISPLAY_LAYOUT.TENANT_EXTERNAL_ONLY,
    })
  }
  if (!isEngineer && historyRowIsApprOrReject(item)) {
    return createWorkPermitHistoryDisplayDecision({
      layout: WORK_PERMIT_HISTORY_DISPLAY_LAYOUT.TENANT_APPROVER_SINGLE,
    })
  }
  return createWorkPermitHistoryDisplayDecision()
}
